/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-31 17:15:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-03 16:58:55
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/ProductCategory/Node/index.tsx
 */
import React from 'react';
//import css from './css.module.less';
import { useDispatch } from 'react-redux';

import HOC from '../HOC';

// import Table from '../Table';
// import { SectionContent } from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
// import Top from 'src/pages/SalesChannelCategory/Components/Card';
import GeneralModal from 'src/pages/SalesChannelCategory/Components/EditModal/General';
import Card from 'src/pages/SalesChannelCategory/ProductCategory/Card';

import { useI18n } from 'src/hooks/useRouterChange';
import {
  getOptions,
  submitChange,
} from 'src/pages/SalesChannelCategory/ProductCategory/EditModal/tools';
import { i18nGet } from 'src/tools/tools';
import { modal } from 'src/utils/Modal';
import { deleteProductCategory, onDataUpdate } from '../slice';

const Node = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();
  const {
    data,
    moveList,
    salesChannelUuid,
    userPermissions,
    setShowModal,
    setModalTitle,
    setModalContent,
    onModalCancel,
  } = props;

  const {
    //path = [],
    uuid,
    salesChannelItems = [],
    name,
    urlSlug,
    parentUuid,
    fullUrl,
  } = data || {};

  const isRoot = !parentUuid;

  const parentNode = moveList.find((i) => i.value === parentUuid);
  const parentName = parentNode ? parentNode.label : '';

  const handleOnDataUpdate = (data: any) => {
    _d(onDataUpdate({ data }));
    //onModalCancel();
  };

  const handleOnDelete = () => {
    //_d(deleteProductCategory({ uuid }));
    onModalCancel();
    modal.error({
      title: getI18n('salesChannelCategoryProducts.index.deleteCategory'),
      content: getI18n(
        'salesChannelCategoryProducts.index.deleteCategoryContent',
      ),
      okText: getI18n('general.delete'),
      onOk: () => {
        _d(deleteProductCategory({ uuid }));
      },
    });
  };
  //====request
  const optionsId = `postGetOptions${salesChannelUuid}`;
  const submissionId = `postCategoryProduct${salesChannelUuid}`;
  const requestId = [optionsId, submissionId];
  const _getOptions = ({ setOptions }) => {
    return getOptions({
      salesChannelUuid,
      selfUuid: uuid,
      requestId: optionsId,
      setOptions,
    });
  };
  const _submitChange = ({ urlSlug, parentUuid, name }) => {
    return submitChange({
      salesChannelUuid,
      selfUuid: uuid,
      requestId: submissionId,
      urlSlug,
      parentUuid,
      name,
      onOk: handleOnDataUpdate,
    });
  };
  //===request
  const onEdit = () => {
    setModalTitle(getI18n('salesChannelCategoryProducts.index.editCategory'));

    setModalContent(
      <GeneralModal
        onGetOptions={_getOptions}
        onSubmit={_submitChange}
        requestId={requestId}
        onDelete={userPermissions.canDelete && handleOnDelete}
        onOk={handleOnDataUpdate}
        salesChannelUuid={salesChannelUuid}
        onCancel={onModalCancel}
        name={name}
        parentUuid={parentUuid}
        urlSlug={urlSlug}
        uuid={uuid}
        slugCheckingUrl={'portal/salesChannel/category/products/checkUrlSlug'}
      />,
    );

    setShowModal(true);
  };

  return (
    <React.Fragment>
      <Card
        onEdit={onEdit}
        name={name}
        slug={urlSlug}
        url={fullUrl}
        uuid={`generalNode${uuid}`}
        products={salesChannelItems}
        moveList={moveList}
        parent={parentName}
        salesChannelUuid={salesChannelUuid}
        isRoot={isRoot}
        userPermissions={userPermissions}
      />
    </React.Fragment>
  );
};

export default HOC(Node, {});
